import { TemplateConfig } from '../Templar/RenderPdfPrescription';
import { PUSH_M_CERT } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export enum COMMUNICATION {
    LATER = 'later',
    OFF = 'off',
    SENT = 'sent',
    ERROR = 'error',
    NOT_APPLICABLE = 'na',
}

export type Response = {
    id?: string;
    success: boolean;
    url?: string;
    isSent?: boolean;
    communication?: COMMUNICATION;
};

export interface RequestData {
    patientid: string;
    clinicid: string;
    contentObject: {
        heading: string;
        description: string;
    };
    params?: { [k: string]: string };
    renderPdfConfig?: TemplateConfig;
    renderPdfSendConfig?: TemplateConfig;
}

export default (docid: string, request: RequestData): Promise<Response> => {
    return fetchWithRefresh(PUSH_M_CERT(docid), {
        method: 'POST',
        body: JSON.stringify(request),
        headers: {
            'Content-type': 'application/json',
        },
    }).then((res) => {
        if (res.status === 200) {
            return res.json();
        } else {
            throw new Error('failed to create m-cert');
        }
    });
};
